import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppRoutes from "../routes";
import DevicesProvider from "../__state/Devices";
import DeviceEntriesProvider from "../__state/DeviceEntries";
import DataWindowProvider from "../__state/DataWindowCollapse";
import ViewChoiceProvider from "../__state/ViewChoice";
import LatestDeviceImagesProvider from "../__state/LatestDeviceImages";
import PaginationProvider from "../__state/Pagination";
import LargeGraphViewProvider from "../__state/LargeGraphView";
import NotificationsProvider from "../__state/Notifications";
import ThemeProvider from "../__state/ThemeContext";

import "./App.scss";
import CloseIcon from "@mui/icons-material/Close"; 

const App = () => {
  const [showMaintenance, setShowMaintenance] = useState(false);
  const navigate = useNavigate(); 

  const detectValidToken = () => {
    if (!sessionStorage.getItem("selfData")) {
      navigate("/"); 
    }
  };

  return (
    <>
      {showMaintenance && (
        <div className="maintenance-banner">
          <p>
            Quantimet will be undergoing maintenance the evening of December 8. 
            Services will be down temporarily during this time. Thanks for your patience.
          </p>
          <div role="button" onClick={() => setShowMaintenance(false)}>
            <CloseIcon />
          </div>
        </div>
      )}
      <div className={`app-wrapper ${showMaintenance ? "with-maintenance" : ""}`}>
        <div className="body-wrapper">
          <ThemeProvider>
            <DevicesProvider>
              <DataWindowProvider>
                <DeviceEntriesProvider>
                  <ViewChoiceProvider>
                    <LatestDeviceImagesProvider>
                      <PaginationProvider>
                        <LargeGraphViewProvider>
                          <NotificationsProvider>
                            <AppRoutes detectValidToken={detectValidToken} />
                          </NotificationsProvider>
                        </LargeGraphViewProvider>
                      </PaginationProvider>
                    </LatestDeviceImagesProvider>
                  </ViewChoiceProvider>
                </DeviceEntriesProvider>
              </DataWindowProvider>
            </DevicesProvider>
          </ThemeProvider>
        </div>
      </div>
    </>
  );
};

export default App;
